import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the `}<inlineCode parentName="p">{`totalPrice`}</inlineCode>{` and `}<inlineCode parentName="p">{`price`}</inlineCode>{` of a line item and changes the `}<inlineCode parentName="p">{`priceMode`}</inlineCode>{` of the line item to `}<inlineCode parentName="p">{`ExternalTotal`}</inlineCode>{` `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitempricemode"
        }}>{`LineItemPriceMode`}</a>{`.
If the price mode of the line item is `}<inlineCode parentName="p">{`ExternalTotal`}</inlineCode>{` and no `}<inlineCode parentName="p">{`externalTotalPrice`}</inlineCode>{` is given, the external price is unset
and the `}<inlineCode parentName="p">{`priceMode`}</inlineCode>{` is set to `}<inlineCode parentName="p">{`Platform`}</inlineCode>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setLineItemTotalPrice"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalTotalPrice`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#externallineitemtotalprice"
          }}>{`ExternalLineItemTotalPrice`}</a>{` - Optional`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      